import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function AboutUs() {
  return <ComingSoon title="About Us" />;
}
